import { func, string, number, oneOfType, node, object } from 'prop-types'
import { css } from '@emotion/react'

import mediaQueries from '@/layout/media-queries'
import { MarkdownRender } from '@/components/MarkdownRender'
import { useClientLoadedContext } from '@/context/clientLoaded'

const itemCss = (cols, color) => css`
  box-shadow: inset 4px 0px 0px ${color};
  padding: 0 20px;
  margin-top: 12px;
  margin-bottom: 12px;
  flex-grow: 1;

  ${mediaQueries.mediumScreen()} {
    ${cols === 1 &&
    `
      flex-basis: 100%;
      max-width: 100%;
    `}

    ${cols === 2 &&
    `
      flex-basis: 50%;
      max-width: 50%;
    `}

    ${cols === 3 &&
    `
      flex-basis: 33%;
      max-width: 33%;
    `}
  }
`

const titleCss = (theme) => css`
  font-size: 16px;
  font-weight: ${theme.font.bold};
`

const descriptionCss = css`
  > div {
    p {
      word-break: break-word;
    }

    p:first-of-type {
      margin-top: 4px;
    }

    p:last-of-type {
      margin-bottom: 0;
    }

    ul {
      margin-bottom: 0;
    }
  }
`

export const Item = ({ title, description, cols, color }) => {
  const isClientLoaded = useClientLoadedContext()

  return (
    <div css={itemCss(cols, color)}>
      <div css={titleCss}>{title}</div>

      <div css={descriptionCss}>
        <MarkdownRender content={description} isRawMarkdown={isClientLoaded} />
      </div>
    </div>
  )
}

Item.propTypes = {
  title: oneOfType([string, func, node, object]),
  description: string,
  cols: number,
  color: string,
}

export default Item
